/* Keep the existing category tree usable independently of the product/page column. */
if (!customElements.get('zd-context-navigation')) {
  customElements.define('zd-context-navigation', class extends HTMLElement {
    connectedCallback() {
      this.nav = this.closest('.zd-collection-side-nav');
      this.disclosure = this.querySelector('details');
      this.summary = this.querySelector('summary');
      if (!this.nav || !this.disclosure || !this.summary) return;
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const activeLinks = [...this.querySelectorAll('a.is-active')];
      const current = this.querySelector('.zd-collection-side-nav__current');
      if (current && activeLinks.length) {
        current.textContent = activeLinks.slice(-2).map(link => link.textContent.trim()).join(' / ');
      }
      this.changeMode = () => {
        this.disclosure.open = this.desktop.matches;
        this.scheduleMeasure();
      };
      this.scheduleMeasure = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const preview = document.getElementById('PBarNextFrame');
          const bottom = preview ? Math.min(64, Math.max(0, window.innerHeight - preview.getBoundingClientRect().top)) : 0;
          if (!this.desktop.matches) {
            const panelTop = Math.max(16, this.summary.getBoundingClientRect().bottom);
            this.nav.style.setProperty('--zd-side-panel-height', `${Math.max(160, window.innerHeight - panelTop - bottom - 16)}px`);
            return;
          }
          const top = Math.max(16, this.nav.getBoundingClientRect().top);
          this.nav.style.setProperty('--zd-side-nav-height', `${Math.max(0, window.innerHeight - top - bottom - 16)}px`);
        });
      };
      this.disclosure.addEventListener('toggle', () => {
        if (this.desktop.matches || !this.disclosure.open) return;
        this.scheduleMeasure();
        const panel = this.querySelector('.zd-collection-side-nav__content');
        const active = activeLinks[activeLinks.length - 1];
        if (panel && active) {
          panel.scrollTop = Math.max(0, panel.scrollTop + active.getBoundingClientRect().top - panel.getBoundingClientRect().top - 56);
        }
      }, options);
      this.desktop.addEventListener('change', this.changeMode, options);
      window.addEventListener('resize', this.scheduleMeasure, options);
      window.addEventListener('scroll', this.scheduleMeasure, { ...options, passive: true });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || this.desktop.matches || !this.disclosure.open) return;
        this.disclosure.open = false;
        this.summary.focus();
        event.stopPropagation();
      }, options);
      this.sizeObserver = new ResizeObserver(this.scheduleMeasure);
      this.sizeObserver.observe(document.documentElement);
      this.changeMode();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.sizeObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
